import { Enums } from "../../../models/common"
import { OpLocation } from "../../../models/core"

// #region LocationMassGroupsAssigningErrorCode

export enum LocationMassGroupsAssigningErrorCode {
    Succeded = 0,
    Failed = 1
}

// #endregion

// #region LocationsMassGroupsAssigningProgressStep

export class LocationsMassGroupsAssigningProgressStep {
    public itemsCount: number
    public successItemsCount: number
    public errorItemsCount: number

    constructor(obj: any = null) {
        if (obj != null) {
            this.itemsCount = obj.itemsCount
            this.successItemsCount = obj.successItemsCount
            this.errorItemsCount = obj.errorItemsCount
        } else {
            this.itemsCount = 0
            this.successItemsCount = 0
            this.errorItemsCount = 0
        }
    }
}

// #endregion

// #region ILocationsMassGroupsEdit

export interface ILocationsMassGroupsEdit {
    show(): void
    hide(): void
    setLocations(locations: OpLocation[]): void
}

// #endregion

// #region

export type LocationsMassGroupsEditOptions = {
    referenceType: Enums.ReferenceType
    moduleName: Enums.SimaxModuleName

    onInitialized?: (controller: ILocationsMassGroupsEdit) => void
    onSaved?: () => void
}

// #endregion